var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('div',{staticClass:"settings settings--manage-vessels pt-5",class:_vm.themeClass},[_c('DataTable')],1)}
var staticRenderFns = []

export { render, staticRenderFns }